//import router from "@/router";
import Cookies from "js-cookie";
import { getUrlParams, initLocalName } from "@/utils";
import { Cats } from "@/api/user";
import { db } from "@/db";

const state = {
  API_TOKEN:
    process.env.NODE_ENV == "development" ? process.env.VUE_APP_API_TOKEN : "", //getToken(),
  name: "", //用户名
  languageMode: localStorage.getItem("languageMode")
    ? localStorage.getItem("languageMode")
    : "system", //语言模式 system , source , both
  SHowMainHead: false, // 是否显示主页面中的头部栏
  ebayShowMainHead: false, // 是否显示ebay主页面中的头部栏
  publicShowMainHead: false, // 是否显示amazon和jd主页面中的头部栏
  SHowTopHead: true, //是否显示系统顶部栏
  ShowEbayTopHead: false, //是否显示ebay系统顶部栏
  selectedKeyWards: getUrlParams("word") ? getUrlParams("word") : "", //页面顶部输入框中输入的搜索条件
  plants: getUrlParams("plat")
    ? getUrlParams("plat").split(",")
    : ["douyin", "weibo", "xhs"], //选择的平台
  //logingState: true, //登陆过状态 false:未登录  true:已登录
  loginInfo: {}, //登陆后的信息
  loginCatList: "", //登陆用户的类目权限
  jdLoginCatList: "", //登陆用户的京东类目权限
  chanceLoginCatList: "", //登录用户的Brand/Category类目权限
  chanceJdLoginCatList: '', // 登录用户的Brand/Category类目权限
  ebayLoginCatList: "", //登陆用户的ebay类目权限
  amazonLoginCatList: "", //登陆用户的amazon类目权限
  amazonDeLoginCatList: "", //登陆用户的amazon_de类目权限
  amazonUkLoginCatList: "", //登陆用户的amazon_uk类目权限
  amazonJpLoginCatList: "", //登陆用户的amazon_jp类目权限
  douyinLoginCatList: "", //登录用户的douyin类目权限
  shopeeIdLoginCatList: "", //登录用户的shopee_id类目权限
  shopeeThLoginCatList: "", //登录用户的shopee_th类目权限
  shopeeVnLoginCatList: "", //登录用户的shopee_vn类目权限
  shopeeMyLoginCatList: "", //登录用户的shopee_my类目权限
  shopeePhLoginCatList: "", //登录用户的shopee_ph类目权限
  shopeeSgLoginCatList: "", //登录用户的shopee_sg类目权限
  lazadaMyLoginCatList: "", //登录用户的lazada_my类目权限
  lazadaSgLoginCatList: "", //登录用户的lazada_sg类目权限
  lazadaIdLoginCatList: "", //登录用户的lazada_id类目权限
  lazadaPhLoginCatList: "", //登录用户的lazada_ph类目权限
  lazadaThLoginCatList: "", //登录用户的lazada_th类目权限
  lazadaVnLoginCatList: "", //登录用户的lazada_vn类目权限
  loginCatlevel: [], //登陆用户的类目权限日期列表
  jdLoginCatlevel: [], // 登录用户的京东类目权限列表
  chanceLoginCatlevel: [], // 登录用户的Brand/Category模块权限
  chanceJdLoginCatlevel: [], // 登录用户的Brand/Category模块京东权限
  ebayLoginCatlevel: [], // 登录用户的ebay类目权限列表
  amazonLoginCatlevel: [], // 登录用户的amazon类目权限列表
  amazonDeLoginCatlevel: [], // 登录用户的amazon_de类目权限列表
  amazonUkLoginCatlevel: [], // 登录用户的amazon_uk类目权限列表
  amazonJpLoginCatlevel: [], // 登录用户的amazon_jp类目权限列表
  douyinLoginCatlevel: [], // 登录用户的douyin类目权限列表
  shopeeIdLoginCatlevel: [], // 登录用户的shopee_id类目权限列表
  shopeeThLoginCatlevel: [], // 登录用户的shopee_th类目权限列表
  shopeeVnLoginCatlevel: [], // 登录用户的shopee_vn类目权限列表
  shopeeMyLoginCatlevel: [], // 登录用户的shopee_my类目权限列表
  shopeePhLoginCatlevel: [], // 登录用户的shopee_ph类目权限列表
  shopeeSgLoginCatlevel: [], // 登录用户的shopee_sg类目权限列表
  lazadaMyLoginCatLevel: [], // 登陆用户的lazada_my类目权限列表
  lazadaSgLoginCatLevel: [], // 登陆用户的lazada_sg类目权限列表
  lazadaIdLoginCatLevel: [], // 登陆用户的lazada_id类目权限列表
  lazadaPhLoginCatLevel: [], // 登陆用户的lazada_ph类目权限列表
  lazadaThLoginCatLevel: [], // 登陆用户的lazada_th类目权限列表
  lazadaVnLoginCatLevel: [], // 登陆用户的lazada_vn类目权限列表
  ActivedMnenue: "1-1", //当前选中的menue
  ActivedTab: localStorage.getItem("passActivedTab")
    ? localStorage.getItem("passActivedTab")
    : "TrendList", //当前选中的tab
  ActivedTabArr: [], //当前需要隐藏的tab索引数组
  ebayActivedTab: localStorage.getItem("ebayActivedTab")
    ? localStorage.getItem("ebayActivedTab")
    : "EbayTrendList", //当前选中的tab
  publicActivedTab: localStorage.getItem("publicActivedTab")
    ? localStorage.getItem("publicActivedTab")
    : "otherTrendList", //当前amazon详情页选中的tab
  publicActivedTabArr: [],//亚马逊当前需要隐藏的tab索引数组
  ebayCId: getUrlParams("ebayCId") ? getUrlParams("ebayCId") : "",
  ebayCName: "",
  ebayBId: getUrlParams("ebayBId") ? getUrlParams("ebayBId") : "",
  ebayBName: "",
  ebayWord: getUrlParams("ebayWord") ? getUrlParams("ebayWord") : "",
  ebayTs: getUrlParams("ebayTs") ? getUrlParams("ebayTs") : "",
  ebayDetailData: {},
  cat_id: getUrlParams("cid") ? getUrlParams("cid") : "16", //页面顶部下拉框选择的类目id
  cat_name: "", //页面顶部下拉框选择的类目名称
  brand_id: getUrlParams("bid") ? getUrlParams("bid") : "", //页面顶部品牌id
  brand_name: "", //页面顶部品牌名称
  ts: getUrlParams("ts") ? getUrlParams("ts") : "", //全局搜索的日期条件/月份
  catsInfo: {
    bigCategory: [],
    childrenList: {},
  },
  catsInfoJd: { // 京东类目数据
    bigCategory: [],
    childrenList: {},
  },
  catPickerOptions: [],
  catPickerJdOptions: [], // 京东类目选项数据
  isAdmin: true,
  showDownloadBtn: true,
  version: getUrlParams("version") ? getUrlParams("version") : "", //优惠券版本
  jdVersion: "",
  isMultiMonth: false,
  // moneySymbol: '$',
};

const mutations = {
  SET_API_TOKEN: (state, data) => {
    state.API_TOKEN = data;
  },
  SET_SHOW_MAIN_HEAD: (state, data) => {
    state.SHowMainHead = data;
  },
  SET_EBAY_SHOW_MAIN_HEAD: (state, data) => {
    state.ebayShowMainHead = data;
  },
  SET_PUBLIC_SHOW_MAIN_HEAD: (state, data) => {
    state.publicShowMainHead = data;
  },
  SET_SHOW_TOP_HEAD: (state, data) => {
    state.SHowTopHead = data;
  },
  SET_SHOW_EBAY_TOP_HEAD: (state, data) => {
    state.ShowEbayTopHead = data;
  },
  SET_SELECTED_TYPE: (state, data) => {
    state.selectedType = data;
  },
  SET_NAME: (state, data) => {
    state.name = data;
  },
  SET_LOGININFO: (state, data) => {
    state.loginInfo = data;
  },
  SET_LOGINCATLIST: (state, data) => {
    state.loginCatList = data;
  },
  SET_JDLOGINCATLIST: (state, data) => {
    state.jdLoginCatList = data;
  },
  SET_CHANCELOGINCATLIST: (state, data) => {
    state.chanceLoginCatList = data;
  },
  SET_CHANCEJDLOGINCATLIST: (state, data) => {
    state.chanceJdLoginCatList = data;
  },
  SET_EABYLOGINCATLIST: (state, data) => {
    state.ebayLoginCatList = data;
  },
  SET_AMAZONLOGINCATLIST: (state, data) => {
    state.amazonLoginCatList = data;
  },
  SET_AMAZONDELOGINCATLIST: (state, data) => {
    state.amazonDeLoginCatList = data;
  },
  SET_AMAZONUKLOGINCATLIST: (state, data) => {
    state.amazonUkLoginCatList = data;
  },
  SET_AMAZONJPLOGINCATLIST: (state, data) => {
    state.amazonJpLoginCatList = data;
  },
  SET_DOUYINLOGINCATLIST: (state, data) => {
    state.douyinLoginCatList = data;
  },
  SET_SHOPEEIDLOGINCATLIST: (state, data) => {
    state.shopeeIdLoginCatList = data;
  },
  SET_SHOPEETHLOGINCATLIST: (state, data) => {
    state.shopeeThLoginCatList = data;
  },
  SET_SHOPEEVNLOGINCATLIST: (state, data) => {
    state.shopeeVnLoginCatList = data;
  },
  SET_SHOPEEMYLOGINCATLIST: (state, data) => {
    state.shopeeMyLoginCatList = data;
  },
  SET_SHOPEEPHLOGINCATLIST: (state, data) => {
    state.shopeePhLoginCatList = data;
  },
  SET_SHOPEESGLOGINCATLIST: (state, data) => {
    state.shopeeSgLoginCatList = data;
  },
  SET_LAZADAMYLOGINCATLIST: (state, data) => {
    state.lazadaMyLoginCatList = data;
  },
  SET_LAZADASGLOGINCATLIST: (state, data) => {
    state.lazadaSgLoginCatList = data;
  },
  SET_LAZADAIDLOGINCATLIST: (state, data) => {
    state.lazadaIdLoginCatList = data;
  },
  SET_LAZADAPHLOGINCATLIST: (state, data) => {
    state.lazadaPhLoginCatList = data;
  },
  SET_LAZADATHLOGINCATLIST: (state, data) => {
    state.lazadaThLoginCatList = data;
  },
  SET_LAZADAVNLOGINCATLIST: (state, data) => {
    state.lazadaVnLoginCatList = data;
  },
  SET_LOGINCATLEVEL: (state, data) => {
    state.loginCatlevel = data;
  },
  SET_JDLOGINCATLEVEL: (state, data) => {
    state.jdLoginCatlevel = data;
  },
  SET_CHANCELOGINCATLEVEL: (state, data) => {
    state.chanceLoginCatlevel = data;
  },
  SET_CHANCEJDLOGINCATLEVEL: (state, data) => {
    state.chanceJdLoginCatlevel = data;
  },
  SET_EBAYLOGINCATLEVEL: (state, data) => {
    state.ebayLoginCatlevel = data;
  },
  SET_AMAZONLOGINCATLEVEL: (state, data) => {
    state.amazonLoginCatlevel = data;
  },
  SET_AMAZONDELOGINCATLEVEL: (state, data) => {
    state.amazonDeLoginCatlevel = data;
  },
  SET_AMAZONUKLOGINCATLEVEL: (state, data) => {
    state.amazonUkLoginCatlevel = data;
  },
  SET_AMAZONJPLOGINCATLEVEL: (state, data) => {
    state.amazonJpLoginCatlevel = data;
  },
  SET_DOUYINLOGINCATLEVEL: (state, data) => {
    state.douyinLoginCatlevel = data;
  },
  SET_SHOPEEIDLOGINCATLEVEL: (state, data) => {
    state.shopeeIdLoginCatlevel = data;
  },
  SET_SHOPEETHLOGINCATLEVEL: (state, data) => {
    state.shopeeThLoginCatlevel = data;
  },
  SET_SHOPEEVNLOGINCATLEVEL: (state, data) => {
    state.shopeeVnLoginCatlevel = data;
  },
  SET_SHOPEEMYLOGINCATLEVEL: (state, data) => {
    state.shopeeMyLoginCatlevel = data;
  },
  SET_SHOPEEPHLOGINCATLEVEL: (state, data) => {
    state.shopeePhLoginCatlevel = data;
  },
  SET_SHOPEESGLOGINCATLEVEL: (state, data) => {
    state.shopeeSgLoginCatlevel = data;
  },
  SET_LAZADAMYLOGINCATLEVEL: (state, data) => {
    state.lazadaMyLoginCatLevel = data
  },
  SET_LAZADASGLOGINCATLEVEL: (state, data) => {
    state.lazadaSgLoginCatLevel = data
  },
  SET_LAZADAIDLOGINCATLEVEL: (state, data) => {
    state.lazadaIdLoginCatLevel = data
  },
  SET_LAZADAPHLOGINCATLEVEL: (state, data) => {
    state.lazadaPhLoginCatLevel = data
  },
  SET_LAZADATHLOGINCATLEVEL: (state, data) => {
    state.lazadaThLoginCatLevel = data
  },
  SET_LAZADAVNLOGINCATLEVEL: (state, data) => {
    state.lazadaVnLoginCatLevel = data
  },
  SET_SELECTED_KEYWARDS: (state, data) => {
    state.selectedKeyWards = data;
  },
  SET_PLANTS: (state, data) => {
    state.plants = data;
  },
  SET_KOL_ID: (state, data) => {
    state.KolId = data;
  },
  SET_KOL_NAME: (state, data) => {
    state.KolName = data;
  },
  SET_POST_KOL_ID: (state, data) => {
    state.post_kolId = data;
  },
  SET_POST_KOL_NAME: (state, data) => {
    state.post_KolName = data;
  },
  SET_START_MONTH: (state, data) => {
    state.startMonth = data;
  },
  SET_END_MONTH: (state, data) => {
    state.endMonth = data;
  },
  SET_ACTIVED_MENUE: (state, data) => {
    state.ActivedMnenue = data;
  },
  SET_ACTIVED_TAB: (state, data) => {
    state.ActivedTab = data;
  },
  SET_EBAY_ACTIVED_TAB: (state, data) => {
    state.ebayActivedTab = data;
  },
  SET_PUBLIC_ACTIVED_TAB: (state, data) => {
    state.publicActivedTab = data;
  },
  SET_ACTIVED_TAB_ARR: (state, data) => {
    state.ActivedTabArr = data;
  },
  SET_PUBLIC_ACTIVED_TAB_ARR: (state, data) => {
    state.publicActivedTabArr = data;
  },
  SET_CLOUD_WORD: (state, data) => {
    state.CloudWord = data;
  },
  SET_BRAND_ID: (state, data) => {
    state.brand_id = data;
  },
  SET_BRAND_NAME: (state, data) => {
    state.brand_name = data;
  },
  SET_CAT_ID: (state, data) => {
    state.cat_id = data;
  },
  SET_CAT_NAME: (state, data) => {
    state.cat_name = data;
  },
  SET_EBAY_CID: (state, data) => {
    state.ebayCId = data;
  },
  SET_EBAY_CNAME: (state, data) => {
    state.ebayCName = data;
  },
  SET_EBAY_BID: (state, data) => {
    state.ebayBId = data;
  },
  SET_EBAY_BNAME: (state, data) => {
    state.ebayBName = data;
  },
  SET_EBAY_WORD: (state, data) => {
    state.ebayWord = data;
  },
  SET_EBAY_TS: (state, data) => {
    state.ebayTs = data;
  },
  SET_EBAY_DETAILDATA: (state, data) => {
    state.ebayDetailData = data;
  },
  SET_TS: (state, data) => {
    state.ts = data;
  },
  SET_CATES_INFO: (state, data) => {
    state.catsInfo = { ...state.catsInfo, ...data };
  },
  SET_CATES_INFO_JD: (state, data) => {
    state.catsInfoJd = { ...state.catsInfoJd, ...data };
  },
  SET_CATPICKER_OPTIONS: (state, data) => {
    state.catPickerOptions = data;
  },
  SET_CATPICKER_JD_OPTIONS: (state, data) => {
    state.catPickerJdOptions = data;
  },
  SET_SHOW_DOWNLOAD_BTN: (state, data) => {
    state.showDownloadBtn = data;
  },
  SET_VERSION: (state, data) => {
    state.version = data;
  },
  SET_JD_VERSION: (state, data) => {
    state.jdVersion = data;
  },
  SET_IS_MULTI_MONTH: (state, data) => {
    state.isMultiMonth = data;
  },
  // SET_MONEY_SYMBOL: (state, data) => {
  //   state.moneySymbol = data;
  // }
  SET_LANGUAGE_MODE: (state, data) => {
    state.languageMode = data;
  },
};

const actions = {
  changeApiToken({ commit, dispatch }, data) {
    commit("SET_API_TOKEN", data);
  },
  changeShowMainHead({ commit, dispatch }, data) {
    commit("SET_SHOW_MAIN_HEAD", data);
  },
  changeEbayShowMainHead({ commit, dispatch }, data) {
    commit("SET_EBAY_SHOW_MAIN_HEAD", data);
  },
  changePublicShowMainHead({ commit, dispatch }, data) {
    commit("SET_PUBLIC_SHOW_MAIN_HEAD", data);
  },
  changeShowTopHead({ commit, dispatch }, data) {
    commit("SET_SHOW_TOP_HEAD", data);
  },
  changeShowEbayTopHead({ commit, dispatch }, data) {
    commit("SET_SHOW_EBAY_TOP_HEAD", data);
  },
  changeSelectedType({ commit, dispatch }, data) {
    commit("SET_SELECTED_TYPE", data);
  },
  changeName({ commit, dispatch }, data) {
    commit("SET_NAME", data);
  },
  changeLoginInfo({ commit, dispatch }, data) {
    commit("SET_LOGININFO", data);
  },
  changeLoginCatList({ commit, dispatch }, data) {
    commit("SET_LOGINCATLIST", data);
  },
  changeJdLoginCatList({ commit, dispatch }, data) {
    commit("SET_JDLOGINCATLIST", data);
  },
  changeChanceLoginCatList({ commit, dispatch }, data) {
    commit("SET_CHANCELOGINCATLIST", data);
  },
  changeChanceJdLoginCatList({ commit, dispatch }, data) {
    commit("SET_CHANCEJDLOGINCATLIST", data);
  },
  changeEbayLoginCatList({ commit, dispatch }, data) {
    commit("SET_EABYLOGINCATLIST", data);
  },
  changeAmazonLoginCatList({ commit, dispatch }, data) {
    commit("SET_AMAZONLOGINCATLIST", data);
  },
  changeAmazonDeLoginCatList ({ commit, dispatch }, data) {
    commit("SET_AMAZONDELOGINCATLIST", data);
  },
  changeAmazonUkLoginCatList ({ commit, dispatch }, data) {
    commit("SET_AMAZONUKLOGINCATLIST", data);
  },
  changeAmazonJpLoginCatList ({ commit, dispatch }, data) {
    commit("SET_AMAZONJPLOGINCATLIST", data);
  },
  changeDouyinLoginCatList({ commit, dispatch }, data) {
    commit("SET_DOUYINLOGINCATLIST", data);
  },
  changeShopeeIdLoginCatList({ commit, dispatch }, data) {
    commit("SET_SHOPEEIDLOGINCATLIST", data);
  },
  changeShopeeThLoginCatList({ commit, dispatch }, data) {
    commit("SET_SHOPEETHLOGINCATLIST", data);
  },
  changeShopeeVnLoginCatList({ commit, dispatch }, data) {
    commit("SET_SHOPEEVNLOGINCATLIST", data);
  },
  changeShopeeMyLoginCatList({ commit, dispatch }, data) {
    commit("SET_SHOPEEMYLOGINCATLIST", data);
  },
  changeShopeePhLoginCatList({ commit, dispatch }, data) {
    commit("SET_SHOPEEPHLOGINCATLIST", data);
  },
  changeShopeeSgLoginCatList({ commit, dispatch }, data) {
    commit("SET_SHOPEESGLOGINCATLIST", data);
  },
  changeLazadaMyLoginCatList({ commit, dispatch }, data) {
    commit("SET_LAZADAMYLOGINCATLIST", data);
  },
  changeLazadaSgLoginCatList({ commit, dispatch }, data) {
    commit("SET_LAZADASGLOGINCATLIST", data);
  },
  changeLazadaIdLoginCatList({ commit, dispatch }, data) {
    commit("SET_LAZADAIDLOGINCATLIST", data);
  },
  changeLazadaPhLoginCatList({ commit, dispatch }, data) {
    commit("SET_LAZADAPHLOGINCATLIST", data);
  },
  changeLazadaThLoginCatList({ commit, dispatch }, data) {
    commit("SET_LAZADATHLOGINCATLIST", data);
  },
  changeLazadaVnLoginCatList({ commit, dispatch }, data) {
    commit("SET_LAZADAVNLOGINCATLIST", data);
  },
  changeLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_LOGINCATLEVEL", data);
  },
  changeJdLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_JDLOGINCATLEVEL", data);
  },
  changeChanceLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_CHANCELOGINCATLEVEL", data);
  },
  changeChanceJdLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_CHANCEJDLOGINCATLEVEL", data);
  },
  changeEbayLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_EBAYLOGINCATLEVEL", data);
  },
  changeAmazonLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_AMAZONLOGINCATLEVEL", data);
  },
  changeAmazonDeLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_AMAZONDELOGINCATLEVEL", data);
  },
  changeAmazonUkLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_AMAZONUKLOGINCATLEVEL", data);
  },
  changeAmazonJpLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_AMAZONJPLOGINCATLEVEL", data);
  },
  changeDouyinLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_DOUYINLOGINCATLEVEL", data);
  },
  changeShopeeIdLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_SHOPEEIDLOGINCATLEVEL", data);
  },
  changeShopeeThLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_SHOPEETHLOGINCATLEVEL", data);
  },
  changeShopeeVnLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_SHOPEEVNLOGINCATLEVEL", data);
  },
  changeShopeeMyLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_SHOPEEMYLOGINCATLEVEL", data);
  },
  changeShopeePhLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_SHOPEEPHLOGINCATLEVEL", data);
  },
  changeShopeeSgLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_SHOPEESGLOGINCATLEVEL", data);
  },
  changeLazadaMyLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_LAZADAMYLOGINCATLEVEL", data);
  },
  changeLazadaSgLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_LAZADASGLOGINCATLEVEL", data);
  },
  changeLazadaIdLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_LAZADAIDLOGINCATLEVEL", data);
  },
  changeLazadaPhLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_LAZADAPHLOGINCATLEVEL", data);
  },
  changeLazadaThLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_LAZADATHLOGINCATLEVEL", data);
  },
  changeLazadaVnLoginCatLevel({ commit, dispatch }, data) {
    commit("SET_LAZADAVNLOGINCATLEVEL", data);
  },
  changeSelectedKeyWards({ commit, dispatch }, data) {
    commit("SET_SELECTED_KEYWARDS", data);
  },
  changeplants({ commit, dispatch }, data) {
    commit("SET_PLANTS", data);
  },
  changeKolId({ commit, dispatch }, data) {
    commit("SET_KOL_ID", data);
  },
  changeKolName({ commit, dispatch }, data) {
    commit("SET_KOL_NAME", data);
  },
  changePostKolId({ commit, dispatch }, data) {
    commit("SET_POST_KOL_ID", data);
  },
  changePostKolName({ commit, dispatch }, data) {
    commit("SET_POST_KOL_NAME", data);
  },
  changeStartMonth({ commit, dispatch }, data) {
    commit("SET_START_MONTH", data);
  },
  changeEndMonth({ commit, dispatch }, data) {
    commit("SET_END_MONTH", data);
  },
  changeActivedMnenue({ commit, dispatch }, data) {
    commit("SET_ACTIVED_MENUE", data);
  },
  changeActivedTab({ commit, dispatch }, data) {
    commit("SET_ACTIVED_TAB", data);
  },
  changeEbayActivedTab({ commit, dispatch }, data) {
    commit("SET_EBAY_ACTIVED_TAB", data);
  },
  changePublicActivedTab({ commit, dispatch }, data) {
    commit("SET_PUBLIC_ACTIVED_TAB", data);
  },
  changeActivedTabArr({ commit, dispatch }, data) {
    commit("SET_ACTIVED_TAB_ARR", data);
  },
  changePublicActivedTabArr({ commit, dispatch }, data) {
    commit("SET_PUBLIC_ACTIVED_TAB_ARR", data);
  },
  changeCloudWord({ commit, dispatch }, data) {
    commit("SET_CLOUD_WORD", data);
  },
  changeBrandId({ commit, dispatch }, data) {
    commit("SET_BRAND_ID", data);
  },
  changeBrandName({ commit, dispatch }, data) {
    commit("SET_BRAND_NAME", data);
  },
  changeCatId({ commit, dispatch }, data) {
    commit("SET_CAT_ID", data);
  },
  changeCatName({ commit, dispatch }, data) {
    commit("SET_CAT_NAME", data);
  },
  changeEbayCId({ commit, dispatch }, data) {
    commit("SET_EBAY_CID", data);
  },
  changeEbayCName({ commit, dispatch }, data) {
    commit("SET_EBAY_CNAME", data);
  },
  changeEbayBId({ commit, dispatch }, data) {
    commit("SET_EBAY_BID", data);
  },
  changeEbayBName({ commit, dispatch }, data) {
    commit("SET_EBAY_BNAME", data);
  },
  changeEbayWord({ commit, dispatch }, data) {
    commit("SET_EBAY_WORD", data);
  },
  changeEbayTs({ commit, dispatch }, data) {
    commit("SET_EBAY_TS", data);
  },
  changeEbayDetailData({ commit, dispatch }, data) {
    commit("SET_EBAY_DETAILDATA", data);
  },
  changeTs({ commit, dispatch }, data) {
    commit("SET_TS", data);
  },
  changeCatPickerOptions({ commit, dispatch }, data) {
    commit("SET_CATPICKER_OPTIONS", data);
  },
  changeCatPickerJdOptions({commit, dispatch}, data){
    commit("SET_CATPICKER_JD_OPTIONS", data)
  },
  changeShowDownloadBtn({commit, dispatch}, data){
    commit("SET_SHOW_DOWNLOAD_BTN", data)
  },
  changeVersion({ commit, dispatch }, data) {
    commit("SET_VERSION", data);
  },
  changeJdVersion({ commit, dispatch }, data) {
    commit("SET_JD_VERSION", data);
  },
  changeIsMultiMonth({ commit, dispatch }, data) {
    commit("SET_IS_MULTI_MONTH", data);
  },
  // changeMoneySymbol({ commit, dispatch }, data) {
  //   commit("SET_MONEY_SYMBOL", data);
  // },
  changeLanguageMode({ commit, dispatch }, data) {
    commit("SET_LANGUAGE_MODE", data);
  },
  async UPLOAD_CATS({ commit, state }, { plat = "tmall", rcid, ts }) {
    let that = this;
    return new Promise(function (resolve, reject) {
      let params = { plat };
      if (rcid) {
        params["rcid"] = rcid;
      }
      if (ts) {
        params["ts"] = ts;
      }
      if (!rcid) {
        // 查询全部类目
        (async () => {
          let hasLocalCats = false;
          try {
            if (params.ts !== "2020-11") {
              hasLocalCats = await checkLocalCats(plat);
            }
          } catch (err) {
            reject(err);
          }
          let loadSiteCatsPromise;
          if (!hasLocalCats) {
            loadSiteCatsPromise = loadSiteCats(params);
          }
          resolve({ hasAll: hasLocalCats, loadAll: loadSiteCatsPromise });
        })().catch(reject)
      } else {
        resolve(loadSiteCats(params));
      }
    });
    function loadSiteCats(params) {
      return new Promise(function (resolve, reject) {
        try {
          //   let {
          //     data: {
          //       result: { bigCategory, childrenList, choice_cat },
          //     },
          //   } = await Cats(params);
          const s = document.createElement("script");
          s.type = "text/javascript";
          s.src = "https://chance.mktindex.com/static/chance/json/bigcats.js";
          // 加载京东类目数据
          const s_jd = document.createElement("script");
          s_jd.type = "text/javascript";
          s_jd.src = "https://comment.mktindex.com/static/lingting/json/bigcats_jd.js";

          document.body.appendChild(s);
          document.body.appendChild(s_jd);

          s.onload = function () {
            if (that.state.user.catsInfo.bigCategory.length > 0) {
              resolve();
              return;
            }
            let datas = {
              data: window.cache_cat,
            };
            let {
              data: {
                result: { bigCategory, childrenList, choice_cat },
              },
            } = datas;
            let clist = childrenList;
            let arrs = [];
            if (that.state.user.loginInfo.cat_list != "all") {
              let cat_list = that.state.user.loginInfo.cat_list;
              let catlevel = that.state.user.loginCatlevel;
              if (catlevel.length == 0) {
                return [];
              }
              Object.keys(cat_list).forEach(function (v) {
                cat_list[v].forEach(function (o, i) {
                  var parents = get_parents(o.cat_id);
                  arrs.push(_.last(parents));
                });
              });
              function get_parents(cid) {
                var cat = clist[cid];
                var pids = [cid];
                let count = 0;
                while (cat.parent_id != "0" && count < 4) {
                  pids.push(cat.parent_id);
                  cat = clist[cat.parent_id];
                  count += 1;
                }
                return pids;
              }
            }
            let bigCategoryArr = _.uniq(arrs);
            let _catsInfo = {
              bigCategory:
                that.state.user.loginInfo.cat_list == "all"
                  ? bigCategory
                  : bigCategoryArr,
              childrenList: {
                ...state.catsInfo.childrenList,
                ...childrenList,
              },
              choice_cat,
            };
            commit("SET_CATES_INFO", _catsInfo);
            if (!params.rcid && state.isAdmin) {
              setAllCatsDb(params.plat, JSON.stringify(that.state.catsInfo));
            }
            resolve();
          };

          // 京东类目的加载
          s_jd.onload = function () {
            if(that.state.user.catsInfoJd.bigCategory.length > 0){
              resolve();
              return;
            }
            let datas = {
              data: window.cache_cat_jd
            }
            let {
              data: {
                result: {bigCategory, childrenList, choice_cat},
              }
            } = datas;
            let clist = childrenList;
            let arrs = [];
            if(that.state.user.loginInfo.cat_list !== "all"){
              let cat_list = that.state.user.loginInfo.cat_list;
              let catlevel = that.state.user.loginCatlevel;
              if (catlevel.length == 0) {
                return [];
              }
              Object.keys(cat_list).forEach(function (v) {
                cat_list[v].forEach(function (o, i) {
                  var parents = get_parents(o.cat_id);
                  arrs.push(_.last(parents));
                });
              });
              function get_parents(cid) {
                var cat = clist[cid];
                var pids = [cid];
                let count = 0;
                while (cat && cat.parent_id != "0" && count < 4) {
                  pids.push(cat.parent_id);
                  cat = clist[cat.parent_id];
                  count += 1;
                }
                return pids;
              }
            }
            let bigCategoryArr = _.uniq(arrs);
            let _catsInfoJd = {
              bigCategory:
                that.state.user.loginInfo.cat_list == "all"
                  ? bigCategory
                  : bigCategoryArr,
              childrenList: {
                ...state.catsInfoJd.childrenList,
                ...childrenList,
              },
              choice_cat,
            };
            commit("SET_CATES_INFO_JD", _catsInfoJd);
            resolve();
          }
        } catch (err) {
          reject(err);
        }
      });
    }

    function checkLocalCats(plat = "all") {
      if (!state.isAdmin) {
        return Promise.resolve(false);
      }
      return db.cats_tree.get(plat).then(function (data) {
        try {
          if (data && data.value) {
            commit("SET_CATES_INFO", JSON.parse(data.value));
            return true;
          } else {
            return false;
          }
        } catch (err) {
          return false;
        }
      });
    }
    function setAllCatsDb(plat = "all", cats) {
      return db.cats_tree
        .put({ plat, value: cats })
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
